// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__FUxSd","faqItem":"FAQ_faqItem__rfhhU","faqQuestion":"FAQ_faqQuestion__mXfnv","faqAnswer":"FAQ_faqAnswer__Y2qsv"};